module.exports = __webpack_public_path__ + "img/D5D5D5_929292_ACACAC_B4B4B4-256px.664e19da.png";